import React from 'react';
import App from 'components/App';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isSessionStorageSupported } from 'lib/helpers';
import { SESSION_STORAGE_TOKEN_KEY } from '../../constants';
import useAuthSessionBootstrap from 'utils/useAuthSessionBootstrap';
import useCandidateHydration from 'utils/useCandidateHydration';
import useSessionTimeout from 'utils/useSessionTimeout';

const Layout: React.FC = () => {
  const portal = useSelector((state: any) => state.portal);

  const { token: portalToken } = portal;

  useSessionTimeout();
  useAuthSessionBootstrap();
  useCandidateHydration();

  // Persist the portal token to sessionStorage so legacy code paths
  // (which read directly from sessionStorage) can still authorize requests.
  React.useEffect(() => {
    if (portalToken && isSessionStorageSupported()) {
      window.sessionStorage.setItem(SESSION_STORAGE_TOKEN_KEY, portalToken);
    }
  }, [portalToken]);

  return (
    <App>
      <Outlet />
    </App>
  );
};

export default Layout;
